export default __webpack_public_path__ + "static/media/expense.92abcaa4.svg";